<template>
  <div class="preview_page">
    <div _title="面包屑">
      <div class="preview_bread">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'indexPage' }"
            >素材库首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>新文科</el-breadcrumb-item>
          <el-breadcrumb-item>当前作品</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div _title="主体" class="clearfix">
      <div _title="左侧" class="preview_left">
        <div class="preview_left_block" id="recommend">
          <div _title="标题和预览图" class="preview_info">
            <div _title="第一行" class="preview_info_line preview_info_first">
              <h1 class="preview_info_title">
                <span>{{ fileDetail.categoryName || '新文科' }}</span> {{ fileDetail.name }}
                <p class="h1_p">
                  <em> <i class="iconfont iconai-eye"></i>{{ fileDetail.pv || 0 }} </em>
                  <em> <i class="iconfont iconaixin"></i>{{ fileDetail.laud || 0 }} </em>
                </p>
              </h1>
              <div
                class="preview_info_fav_not"
                v-show="!fileDetail.collect"
                @click="toggleLike()"
              >
                <div class="preview_info_fav_line">
                  <i class="el-icon-star-off"></i>
                  <span class="preview_info_fav_text">收藏</span>
                </div>
              </div>
              <div
                class="preview_info_fav"
                v-show="fileDetail.collect"
                @click="toggleLike()"
              >
                <div class="preview_info_not">
                  <i class="el-icon-star-on"></i>
                  <span class="preview_info_fav_text">已收藏</span>
                </div>
              </div>
            </div>

            <ul>
              <li v-for="(item, index) in imageList" :key="index">
                <div class="m-center-cntr">
                  <div class="t-c">
                    <img
                      class="preview_img_list_item_cover"
                      :src="item"
                      alt=""
                    />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="preview_left_block" style="padding: 10px">
          <div class="preview_left_like">
            <h6 class="p_left_title">相关推荐</h6>
            <!-- 新文科推荐内容 -->
            <div class="articles-list ppt-list">
              <article
                class="post"
                v-for="(item, index) in recommendList.slice(0, 12)"
                :key="index"
              >
                <div class="inner" @click="jumpToDetail(item)" style="width: 195px">
                  <div class="media-pic">
                    <img
                      :src="item.cover || item.image"
                      width="600"
                      height="400"
                      alt=""
                      class="wp-post-image"
                    />
                  </div>
                  <div class="media-body">
                    <a class="title" :title="item.name">
                      {{ item.name }}
                    </a>
                  </div>
                  <div class="clearfix">
                    <p class="post-meta fr">
                      <em>
                        <i class="iconfont iconai-eye"></i>{{ item.pv }}
                      </em>
                      <em>
                        <i class="iconfont iconaixin"></i>{{ item.laud }}
                      </em>
                    </p>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
      <div _title="右侧" class="preview_right">
        <div class="preview_right_block">
          <div>
            <!-- 下载信息 -->
            <div>
              <h3 class="wb-title">下载信息</h3>

              <!-- 价格信息 -->
              <div v-if="!canDownload">
                <span class="preview_price_title">单 价：</span>
                <span _title="现价">
                  <span class="preview__price">
                    ￥
                    <span _title="现价数值" class="preview_price_final_value">
                      {{ fileDetail.price || 0 }}
                    </span>
                  </span>
                </span>
              </div>

              <!-- 操作按钮 -->
              <div>
                <div
                  class="Downloadnow"
                  @click="buy()"
                  v-show="!canDownload"
                >
                  购买
                </div>
                <div
                  class="Downloadnow"
                  v-show="canDownload"
                  @click="download()"
                >
                  直接下载
                </div>

                <p class="botto_p">
                  <span class="copyinfo_title">温馨提示：</span>
                  <span>建议使用Microsoft Office、WPS打开文件，以避免可能出现的排版错乱问题。</span>
                </p>
                <p class="botto_p">
                  <span class="copyinfo_title">授权范围：</span>
                  <span>可做商用</span>
                </p>
                <p class="botto_p">
                  <span class="copyinfo_title">授权对象：</span>
                  <span class="copy_one">个人</span>
                  <span class="copy_two">高校</span>
                </p>
                <p class="botto_p">
                  <span class="copyinfo_title">版权所有：</span>
                  <span>素材库</span>
                </p>
              </div>
            </div>
            <!-- 文件详情 -->
            <ul class="preview_detail clearfix">
              <li class="preview_detail_item">编号: {{ fileDetail.code }}</li>
              <li class="preview_detail_item">作者: {{ fileDetail.author || '素材库' }}</li>
              <li class="preview_detail_item">页数: {{ fileDetail.pageCount || fileDetail.page || 0 }}页</li>
              <li class="preview_detail_item">格式: {{ fileDetail.format }}</li>
              <li class="preview_detail_item">分类: {{ fileDetail.categoryName }}</li>
              <li class="preview_detail_item">类别: {{ fileDetail.subcategoryName }}</li>
            </ul>
          </div>
        </div>
        <!-- 相关片段 -->
        <div
          class="preview_like_block"
          id="torecommed"
          :class="
            Fixed ? 'preview_like_fixed' : Fixeds ? 'preview_like_bottom' : ''
          "
        >
          <div class="preview_like">
            <h6 class="preview_like_title">相关片段</h6>
            <div class="preview_designer_tab_content clearfix">
              <!-- 新文科相关片段 -->
              <div class="articles-list">
                <!-- 暂时不显示相关片段数据 -->
                <div style="text-align: center; padding: 20px; color: #999;">
                  暂无相关片段
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付弹窗 -->
    <div class="pay_Popup">
      <el-dialog
        title="购买文档"
        :visible.sync="dialogVisible"
        width="780px"
        :before-close="handleClose"
        :show-close="false"
      >
        <i
          class="el-icon-close closei"
          @click="closei()"
          v-show="pay_num != 2"
        ></i>
                  <div v-show="pay_num == 1 && showtime == false">
            <div class="muban_detail">
              <p class="name"><i class="line"></i>{{ orderInfo.title || fileDetail.name || '购买文档' }}</p>
              <p class="ordernum">交易订单：{{ orderInfo.number }}</p>
            <p class="final_price_wrapper">
              实际支付：
              <span class="final_price">
                <span class="symbol">￥</span> {{ fileDetail.price || 0 }}
              </span>
            </p>
          </div>
          <div class="qrcode_wrapper clearfix">
            <!-- 微信 -->
            <div class="pay-wx fl">
              <div class="wx-ewm">
                <img :src="wxPayCode" alt="" />
              </div>
              <div class="wx-icon">
                <img src="./../../assets/wx-icon.png" alt="" />微信扫码支付
              </div>
            </div>
            <!-- 支付宝 -->
            <div class="pay-zfb fr" @click="paybuy()">
              <div class="zfb-ewm">
                <img src="./../../assets/pay-zfb.png" alt="" />
              </div>
              <div class="pay-zfb-btn">
                <img src="./../../assets/zfb-icon.png" alt="" />去支付宝支付
              </div>
            </div>
          </div>
        </div>
        <div class="Paysuccess" v-show="pay_num == 2">
          <div class="Pay_div">
            <i class="el-icon-check"></i>
          </div>
          <p class="Pay_p1">支付成功</p>
          <p class="Pay_p2">{{ time }}S后自动跳转至...</p>
          <p class="Pay_p3" @click="jumps()">立即跳转</p>
        </div>
        <div v-show="showtime == true">
          <div class="mask_bg"></div>
          <div class="loading_wrapper">
            <i></i>
          </div>
        </div>
      </el-dialog>
    </div>
    <BetterLogin :title="title" @childFn="parentFn"></BetterLogin>
  </div>
</template>
<script>
import permissionManager from '../../utils/ecardPermissionManager';

export default {
  data() {
    return {
      fileDetail: {}, // 文件详情
      imageList: [], // 图片列表
      recommendList: [], // 推荐列表
      relatedList: [], // 相关片段列表
      wxPayCode: "",
      Fixed: 0,
      Fixeds: 0,
      dialogVisible: false,
      title: "",
      orderInfo: {},
      showtime: true,
      time: "",
      pay_num: 1,
      // 新文科电子卡权限状态
      hasXinWenKePermission: false,
      permissionLoading: true,
      // 本地订单号（使用文件code作为key，避免跨文件订单号混乱）
      localOrderNumber: "",
      localOrderFileCode: "", // 记录订单号对应的文件code
      timing: null // 支付状态轮询定时器
    };
  },
  computed: {
    // 计算是否可以下载：已购买 或 有电子卡权限
    canDownload() {
      return this.fileDetail.buy === true || this.hasXinWenKePermission;
    }
  },
  methods: {
    // 获取本地缓存的订单号（与当前文件code关联）
    getLocalOrderNumber(fileCode) {
      const orderKey = `order_number_${fileCode}`;
      const orderNumber = localStorage.getItem(orderKey);
      return orderNumber || "";
    },
    
    // 保存订单号到本地缓存（与文件code关联）
    saveLocalOrderNumber(fileCode, orderNumber) {
      const orderKey = `order_number_${fileCode}`;
      if (orderNumber) {
        localStorage.setItem(orderKey, orderNumber);
      } else {
        localStorage.removeItem(orderKey);
      }
    },
    
    // 清除本地订单号缓存
    clearLocalOrderNumber(fileCode) {
      const orderKey = `order_number_${fileCode}`;
      localStorage.removeItem(orderKey);
    },
    
    // 检查新文科电子卡权限
    async checkXinWenKePermission() {
      if (!this.$store.state.token) {
        this.hasXinWenKePermission = false;
        this.permissionLoading = false;
        return;
      }

      try {
        // 使用新的权限检查方法，检查新文科模块权限（模块标识8）
        this.hasXinWenKePermission = await permissionManager.hasXinWenKePermission(
          this.$store.state.token
        );
      } catch (error) {
        console.error('检查新文科电子卡权限失败:', error);
        this.hasXinWenKePermission = false;
      } finally {
        this.permissionLoading = false;
      }
    },

    // 获取文件详情
    async getFileDetail() {
      const code = this.$route.query.code;
      if (!code) {
        this.$message.error('文件编码不能为空');
        return;
      }

      try {
        // 使用正确的API方法，传递token参数
        const token = this.$store.state.token;
        const response = await this.axios.previewXinWenKeFile({ code, token });
        
        if (response.data.code === 200) {
          const data = response.data.data;
          // 根据API响应结构，数据在data.item中
          this.fileDetail = data.item || data;
          
          // 设置分类信息
          if (data.categoryName) {
            this.fileDetail.categoryName = data.categoryName;
          }
          if (data.subcategoryName) {
            this.fileDetail.subcategoryName = data.subcategoryName;
          }
          
          // 确保收藏状态正确初始化
          if (typeof this.fileDetail.collect === 'undefined') {
            this.fileDetail.collect = false;
          }
          
          // 处理图片列表 - 支持多张预览图
          if (this.fileDetail.image) {
            // 如果image字段包含多张图片（用逗号分隔），则分割成数组
            if (typeof this.fileDetail.image === 'string' && this.fileDetail.image.includes(',')) {
              this.imageList = this.fileDetail.image.split(',').map(url => url.trim());
            } else {
              this.imageList = [this.fileDetail.image];
            }
          } else {
            this.imageList = [];
          }
        } else {
          this.$message.error(response.data.msg || response.data.message || '获取文件详情失败');
        }
      } catch (error) {
        console.error('获取文件详情失败:', error);
        this.$message.error('获取文件详情失败');
      }
    },

    // 获取推荐文件
    async getRecommendFiles() {
      const code = this.$route.query.code;
      if (!code) return;

      try {
        const response = await this.axios.getXinWenKeRecommend({ code });
        if (response.data.code === 200) {
          this.recommendList = response.data.data || [];
        }
      } catch (error) {
        console.error('获取推荐文件失败:', error);
      }
    },

    // 获取相关文件
    async getRelatedFiles() {
      // 暂时不获取相关文件数据
      // const code = this.$route.query.code;
      // if (!code) return;

      // try {
      //   // 这里可以调用相关文件接口，暂时使用推荐文件
      //   this.relatedList = this.recommendList.slice(0, 4);
      // } catch (error) {
      //   console.error('获取相关文件失败:', error);
      // }
    },

    // 切换收藏状态
    async toggleLike() {
      if (!this.$store.state.token) {
        this.title = true;
        return;
      }

      try {
        const response = await this.axios.likeXinWenKeFile({
          token: this.$store.state.token,
          code: this.fileDetail.code,
          state: this.fileDetail.collect ? "f" : "t"
        });

        if (response.data.code === 200) {
          // 更新收藏状态
          this.fileDetail.collect = !this.fileDetail.collect;
          
          // 更新点赞数
          if (this.fileDetail.collect) {
            this.fileDetail.laud = (this.fileDetail.laud || 0) + 1;
          } else {
            this.fileDetail.laud = Math.max((this.fileDetail.laud || 0) - 1, 0);
          }
          
          // 强制更新视图
          this.$forceUpdate();
          
          // 显示操作成功消息
          const message = this.fileDetail.collect ? '收藏成功' : '取消收藏成功';
          this.$message.success(message);
        } else {
          this.$message.error(response.data.msg || response.data.message || '操作失败');
        }
      } catch (error) {
        console.error('切换收藏状态失败:', error);
        this.$message.error('操作失败');
      }
    },

    // 购买
    buy() {
      if (!this.$store.state.token) {
        this.title = true;
        return;
      }

      const fileCode = this.fileDetail.code;
      if (!fileCode) {
        this.$message.error('文件信息获取失败，请刷新页面重试');
        return;
      }

      // 优先用本地未支付订单号（必须属于当前文件）
      let orderNumber = this.getLocalOrderNumber(fileCode);
      if (orderNumber) {
        this.checkOrderStatus(orderNumber, fileCode);
      } else {
        this.createOrder();
      }
    },

    // 检查订单状态
    async checkOrderStatus(orderNumber, fileCode) {
      try {
        const response = await this.axios.orderquery({
          params: {
            number: orderNumber,
            token: this.$store.state.token
          }
        });

        if (response.data.code === 200 && response.data.data) {
          const orderData = response.data.data;
          const state = orderData.state;
          
          // 验证订单是否属于当前文件
          if (orderData.code && orderData.code !== fileCode) {
            // 订单不属于当前文件，清除并创建新订单
            this.clearLocalOrderNumber(fileCode);
            this.createOrder();
            return;
          }
          
                      if (state === 0) {
              // 未支付，继续使用该订单号
              this.orderInfo = orderData;
              // 如果orderquery接口返回的数据中没有title，使用fileDetail的name作为备选
              if (!this.orderInfo.title && this.fileDetail.name) {
                this.orderInfo.title = this.fileDetail.name;
              }
              this.localOrderNumber = orderNumber;
              this.localOrderFileCode = fileCode;
              this.dialogVisible = true;
              this.showtime = true; // 显示加载状态
              this.wxPayCode = ""; // 清空之前的二维码
              this.payWithOrderNumber(orderNumber);
              return;
          } else if (state === 1 || state === 7) {
            // 支付完成或金额不符，清除本地订单号
            this.clearLocalOrderNumber(fileCode);
            this.localOrderNumber = "";
            this.localOrderFileCode = "";
          }
        }
        // 没有可用订单号，走正常下单流程
        this.createOrder();
      } catch (error) {
        console.error('检查订单状态失败:', error);
        this.createOrder();
      }
    },

    // 创建订单
    async createOrder() {
      const fileCode = this.fileDetail.code;
      if (!fileCode) {
        this.$message.error('文件信息获取失败，请刷新页面重试');
        return;
      }
      
              this.dialogVisible = true;
        this.showtime = true; // 显示加载状态
        this.wxPayCode = ""; // 清空之前的二维码
        try {
          const response = await this.axios.ordertrade({
            code: fileCode,
            token: this.$store.state.token
          });

          if (response.data && response.data.code === 200 && response.data.data) {
            this.orderInfo = response.data.data;
            // 确保title存在，如果API没有返回title，使用fileDetail.name
            if (!this.orderInfo.title && this.fileDetail.name) {
              this.orderInfo.title = this.fileDetail.name;
            }
            // 保存订单号到本地（与文件code关联）
            this.saveLocalOrderNumber(fileCode, this.orderInfo.number);
            this.localOrderNumber = this.orderInfo.number;
            this.localOrderFileCode = fileCode;
            this.payWithOrderNumber(this.orderInfo.number);
        } else {
          this.$message.info(response.data.message);
          this.dialogVisible = false;
        }
      } catch (error) {
        console.error('创建订单失败:', error);
        this.$message.error('创建订单失败，请重试');
        this.dialogVisible = false;
      }
    },

    // 使用订单号支付
    async payWithOrderNumber(orderNumber) {
      // 清除之前的定时器（如果存在）
      if (this.timing) {
        clearInterval(this.timing);
        this.timing = null;
      }
      
      // 确保显示加载状态
      this.showtime = true;
      this.wxPayCode = "";
      
      try {
        const response = await this.axios.orderpay({
          token: this.$store.state.token,
          number: orderNumber,
          type: "wechat"
        });

                  // 更严格的响应检查，兼容不同环境的响应结构
          if (response && response.data && response.data.code === 200 && response.data.data) {
            const payData = response.data.data;
            
            // 更新订单信息，优先使用支付接口返回的title（支付接口的title更准确）
            // 合并订单信息，确保所有字段都更新，并保证 Vue 响应式
            this.orderInfo = Object.assign({}, this.orderInfo, {
              // 如果支付接口返回了 title，优先使用（即使为空字符串也使用）
              title: payData.hasOwnProperty('title') ? payData.title : this.orderInfo.title,
              number: payData.number || this.orderInfo.number
            });
            
            // 调试日志：确认 title 是否正确更新
            console.log('支付接口返回的title:', payData.title);
            console.log('更新后的orderInfo.title:', this.orderInfo.title);
          
          // 检查是否有payCode
          if (payData.payCode) {
            this.wxPayCode = payData.payCode;
            this.showtime = false; // 隐藏加载，显示二维码
            // 启动支付状态轮询
            this.timing = setInterval(() => {
              this.pay_status();
            }, 2000);
          } else {
            console.error('支付接口返回数据中缺少payCode:', payData);
            this.$message.error('获取支付二维码失败：响应数据异常');
            this.showtime = false;
          }
        } else {
          const errorMsg = (response && response.data && response.data.message) || '获取支付二维码失败';
          console.error('支付接口响应异常:', response);
          this.$message.error(errorMsg);
          this.showtime = false;
        }
      } catch (error) {
        console.error('支付请求失败:', error);
        let errorMsg = '获取支付二维码失败，请重试';
        if (error.response && error.response.data && error.response.data.message) {
          errorMsg = error.response.data.message;
        } else if (error.message) {
          errorMsg = error.message;
        }
        this.$message.error(errorMsg);
        this.showtime = false;
      }
    },

    // 查询支付状态
    async pay_status() {
      try {
        const response = await this.axios.orderquery({
          params: {
            number: this.orderInfo.number,
            token: this.$store.state.token
          }
        });

        if (response.data.code === 200 && response.data.data) {
          const state = response.data.data.state;
          if (state === 1 || state === 7) {
            // 支付完成或金额不符，清除本地订单号
            const fileCode = this.localOrderFileCode || this.fileDetail.code;
            this.clearLocalOrderNumber(fileCode);
            this.localOrderNumber = "";
            this.localOrderFileCode = "";
            // 清除定时器
            if (this.timing) {
              clearInterval(this.timing);
              this.timing = null;
            }
            this.pay_num = 2;
            this.time = 6;
            this.timer();
          }
        }
      } catch (error) {
        console.error('查询支付状态失败:', error);
      }
    },

    // 倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.dialogVisible = false;
        // 清除定时器
        if (this.timing) {
          clearInterval(this.timing);
          this.timing = null;
        }
        location.reload();
      }
    },

    // 跳转到详情页
    jumpToDetail(item) {
      let link = this.$router.resolve({
        name: "XinWenKeDetail",
        query: { code: item.code }
      });
      window.open(link.href, "_blank");
    },

    // 立即跳转
    jumps() {
      this.dialogVisible = false;
      location.reload();
    },

    // 下载文件
    async download() {
      try {
        const response = await this.axios.dl({
          token: this.$store.state.token,
          code: this.fileDetail.code
        });

        if (response.data.code === 200) {
          // 记录下载
          await this.axios.downloadXinWenKeFile({
            code: this.fileDetail.code
          });

          // 获取下载URL，优先使用响应中的URL，否则使用文件详情中的URL
          const downloadUrl = response.data.data?.url || this.fileDetail.url;
          
          var SmallFs = window.__wxjs_environment === "miniprogram";
          if (SmallFs === true) {
            wx.miniProgram.navigateTo({
              url: "/pages/util/download?fileUrl=" + downloadUrl
            });
          } else {
            window.location.href = downloadUrl;
          }
        } else {
          this.$message.error(response.data.message);
        }
      } catch (error) {
        console.error('下载失败:', error);
        this.$message.error('下载失败');
      }
    },

    // 支付宝支付
    async paybuy() {
      try {
        const response = await this.axios.orderpay({
          token: this.$store.state.token,
          number: this.orderInfo.number,
          type: "ali"
        });

        if (response.data.code === 200) {
          let routerData = this.$router.resolve({
            path: "/orderAlipay",
            query: { htmlData: response.data.message }
          });
          // 打开新页面
          const newWin = window.open(routerData.href);
          // 发送token给新窗口
          const token = this.$store.state.token;
          // 轮询等待新窗口加载完成
          const sendToken = () => {
            if (newWin) {
              newWin.postMessage({ token }, window.location.origin);
            }
          };
          // 多次尝试发送，兼容新窗口未及时加载
          let count = 0;
          const timer = setInterval(() => {
            sendToken();
            count++;
            if (count > 10) clearInterval(timer);
          }, 300);
        }
      } catch (error) {
        console.error('支付宝支付失败:', error);
      }
    },

    // 关闭弹窗
    closei() {
      this.dialogVisible = false;
      // 清除支付状态轮询定时器
      if (this.timing) {
        clearInterval(this.timing);
        this.timing = null;
      }
    },

    // 登录回调
    parentFn(payload) {
      this.title = payload;
      // 登录成功后刷新页面同步登录状态
      if (payload === false) {
        // 通知header组件更新登录状态
        if (this.$parent && this.$parent.logintoken) {
          this.$parent.logintoken();
        }
        // 重新检查新文科电子卡权限
        this.checkXinWenKePermission();
        // 重新获取页面数据
        this.getFileDetail();
        this.getRecommendFiles();
        // 暂时不获取相关文件
        // this.getRelatedFiles();
      }
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString();
    },

    handleClose(done) {
      console.log(done);
    },

    handleScroll() {
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      this.Fixed =
        scrollTop > this.floorOne + this.offsetHeight &&
        scrollTop < this.floorTwo + this.reHeight;
      this.Fixeds = scrollTop > this.floorTwo + this.reHeight;
      if (this.Fixeds === true) {
        let obj = document.getElementById("torecommed");
        obj.style.top = 20 + "px";
      }
    },

    getFloorDis() {
      setTimeout(() => {
        let floorOne = document.getElementById("torecommed").offsetTop;
        this.floorOne = floorOne;
        let floorTwo = document.getElementById("recommend").offsetTop;
        this.floorTwo = floorTwo;
      }, 300);
    }
  },
  async mounted() {
    // 检查新文科电子卡权限
    await this.checkXinWenKePermission();
    
    // 获取文件详情
    await this.getFileDetail();
    
    // 获取推荐文件
    await this.getRecommendFiles();
    
    // 暂时不获取相关文件
    // await this.getRelatedFiles();

    this.getFloorDis();
    this.$nextTick(function() {
      setTimeout(() => {
        let head = document.getElementById("torecommed");
        this.offsetHeight = head.offsetHeight;
        let heads = document.getElementById("recommend");
        this.reHeight = heads.offsetHeight;
        window.addEventListener("scroll", this.handleScroll);
      }, 500);
    });
  },
  beforeDestroy() {
    // 组件销毁前清理资源
    // 清除支付状态轮询定时器
    if (this.timing) {
      clearInterval(this.timing);
      this.timing = null;
    }
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style scoped>
@import "../../styles/Page/Detailspage.css";
</style>
<style>
.preview_bread .el-breadcrumb {
  line-height: 51px;
}
.preview_bread .el-breadcrumb__inner a:hover,
.el-breadcrumb__inner.is-link:hover {
  color: #666;
}
.preview_bread .el-breadcrumb__inner.is-link {
  color: #666;
}
.pay_Popup .el-dialog {
  height: 500px;
}
.pay_Popup .el-dialog__header {
  padding: 0 50px 0 20px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #3e3e3f;
  position: relative;
  margin: 0;
}
.pay_Popup .el-dialog__title {
  font-size: 14px;
  color: #3e3e3f;
  line-height: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
}
.pay_Popup .el-dialog__body {
  padding: 0;
}
.SmalP_popup .el-dialog__header {
  padding: 0 0 0 0px;
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  color: #3e3e3f;
  border-bottom: 1px solid #eaecee;
}
.SmalP_popup .el-dialog__title {
  font-size: 14px;
  color: #3e3e3f;
}
.SmalP_popup .el-dialog--center .el-dialog__body {
  padding: 25px 25px 15px;
}
</style>
